// Enviado nos params do socket para o servidor poder recusar bundles antigos
// (ver UserSocket.check_client_version). Suba este número sempre que o contrato
// de socket/subscription mudar e você quiser forçar os clients a recarregar.
export const CLIENT_VERSION = "1";
